(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  addEventListener("load", (event) => {
    if(document.querySelector(".custom-recomendations") !== null){
      const prductRecommendationSwiper = new Swiper(document.querySelector('.products-recommendations-slider__products'), {
              slidesPerView: 1.27,
              spaceBetween: 25,
              cssMode: true,
              centeredSlides: true,
              centeredSlidesBounds: true,
              navigation: {
                nextEl: '.product-slider-next',
                prevEl: '.product-slider-prev',
              },
              breakpoints: {
                767: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 2,
                },
                1000: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 3,
                },
                1100: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 4,
                  spaceBetween: 30
                },
                1500: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 4,
                  spaceBetween: 60
                }
              }
            });
    }
    else{
      const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;

            const prductRecommendationSwiper = new Swiper(document.querySelector('.products-recommendations-slider__products'), {
              slidesPerView: 1.27,
              spaceBetween: 25,
              cssMode: true,
              centeredSlides: true,
              centeredSlidesBounds: true,
              navigation: {
                nextEl: '.product-slider-next',
                prevEl: '.product-slider-prev',
              },
              breakpoints: {
                767: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 2,
                },
                1000: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 3,
                },
                1100: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 4,
                  spaceBetween: 30
                },
                1500: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 4,
                  spaceBetween: 60
                }
              }
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
